import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';
import { getBorderRadius } from 'Components/utils';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

const styles = theme => ({
  root: {
    fontWeight: theme.typography.fontWeightBold,
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    ...getBorderRadius(theme.radius.md, { all: true }),
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    zIndex: theme.zIndex.appBar + 1,
  },
  goBackButton: {
    backgroundColor: theme.palette.facet.accentBlue10,
    borderRadius: theme.radius.xs,
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightFacetMedium,
    padding: theme.spacing(1),
    margin: theme.spacing(2, 0),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    '&:hover': {
      backgroundColor: theme.palette.facet.accentBlue10,
    },
  },
  warningIcon: {
    color: theme.palette.facet.orange,
    marginBottom: theme.spacing(2),
  },
});

const NotActive = ({
  className,
  classes,
  resource,
}) => {
  const { loadPageContentLink } = usePageContentContext();

  return (
    <div
      className={classNames(classes.root, className)}
    >
      <ReportProblemOutlinedIcon
        className={classes.warningIcon}
      />
      <Typography
        variant={'h4'}
        weight={'bold'}
        color={'primary'}
        paragraph
      >
        {'Scenario Needs Validation'}
      </Typography>
      <Typography
        variant={'h5'}
        weight={'book'}
        color={'primary'}
        align={'center'}
      >
        {'Your scenario must be passing validation to be sent in a proposal.'}
      </Typography>
      <TextButton
        className={classes.goBackButton}
        onClick={() => {
          loadPageContentLink(resource.relationship(fr.relationships.view.name).link('related'));
        }}
      >
        {'View Scenario'}
      </TextButton>
    </div>
  );
};

NotActive.defaultProps = {
  className: '',
};

NotActive.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(NotActive);
